export interface Cie10Entry {
  code: string;
  desc: string;
}

// Catálogo CIE-10 enfocado en fisioterapia y rehabilitación (~300 códigos)
export const CIE10: Cie10Entry[] = [
  // ── Columna lumbar ────────────────────────────────────────────────
  { code: 'M54.5', desc: 'Lumbago no especificado' },
  { code: 'M54.4', desc: 'Lumbago con ciática' },
  { code: 'M54.3', desc: 'Ciática' },
  { code: 'M54.1', desc: 'Radiculopatía' },
  { code: 'M51.1', desc: 'Degeneración de disco lumbar con radiculopatía' },
  { code: 'M51.2', desc: 'Otro desplazamiento de disco intervertebral' },
  { code: 'M51.3', desc: 'Degeneración de disco intervertebral lumbar' },
  { code: 'M47.8', desc: 'Espondilosis sin mielopatía ni radiculopatía' },
  { code: 'M47.1', desc: 'Espondilosis con mielopatía' },
  { code: 'M47.2', desc: 'Espondilosis con radiculopatía' },
  { code: 'M43.0', desc: 'Espondilólisis' },
  { code: 'M43.1', desc: 'Espondilolistesis' },
  { code: 'M48.0', desc: 'Estenosis espinal' },
  { code: 'M96.1', desc: 'Síndrome postlaminectomía' },

  // ── Columna cervical ───────────────────────────────────────────────
  { code: 'M54.2', desc: 'Cervicalgia' },
  { code: 'M50.0', desc: 'Trastorno del disco cervical con mielopatía' },
  { code: 'M50.1', desc: 'Trastorno del disco cervical con radiculopatía' },
  { code: 'M50.2', desc: 'Desplazamiento de disco cervical' },
  { code: 'M50.3', desc: 'Degeneración de disco cervical' },
  { code: 'M53.0', desc: 'Síndrome cervicocraneal' },
  { code: 'M53.1', desc: 'Síndrome cervicobraquial' },
  { code: 'M54.0', desc: 'Paniculitis que afecta región cervical' },
  { code: 'S13.4', desc: 'Esguince cervical (latigazo)' },

  // ── Columna torácica ───────────────────────────────────────────────
  { code: 'M54.6', desc: 'Dolor en la columna torácica' },
  { code: 'M51.0', desc: 'Trastornos del disco intervertebral torácico con mielopatía' },
  { code: 'M40.0', desc: 'Cifosis postural' },
  { code: 'M41.1', desc: 'Escoliosis idiopática del adolescente' },
  { code: 'M41.2', desc: 'Otras escoliosis idiopáticas' },
  { code: 'M41.4', desc: 'Escoliosis neuromuscular' },

  // ── Hombro ────────────────────────────────────────────────────────
  { code: 'M75.0', desc: 'Capsulitis adhesiva del hombro (hombro congelado)' },
  { code: 'M75.1', desc: 'Síndrome de manguito rotador' },
  { code: 'M75.2', desc: 'Tendinitis del bíceps' },
  { code: 'M75.3', desc: 'Tendinitis calcificante del hombro' },
  { code: 'M75.5', desc: 'Bursitis del hombro' },
  { code: 'M75.8', desc: 'Otras lesiones del hombro' },
  { code: 'S40.0', desc: 'Contusión del hombro y del brazo superior' },
  { code: 'S43.0', desc: 'Luxación de articulación glenohumeral' },
  { code: 'S46.0', desc: 'Lesión del tendón del manguito rotador' },

  // ── Codo ──────────────────────────────────────────────────────────
  { code: 'M77.0', desc: 'Epicondilitis medial (codo de golfista)' },
  { code: 'M77.1', desc: 'Epicondilitis lateral (codo de tenista)' },
  { code: 'M70.2', desc: 'Bursitis olecraneana' },
  { code: 'S53.0', desc: 'Luxación de la cabeza del radio' },
  { code: 'S53.1', desc: 'Luxación del codo' },

  // ── Muñeca y mano ─────────────────────────────────────────────────
  { code: 'G56.0', desc: 'Síndrome del túnel carpiano' },
  { code: 'M65.3', desc: 'Dedo en gatillo (tenosinovitis estenosante)' },
  { code: 'M65.4', desc: 'Tenosinovitis de De Quervain' },
  { code: 'M70.0', desc: 'Tenosinovitis crónica de mano y muñeca' },
  { code: 'S62.5', desc: 'Fractura de pulgar' },
  { code: 'S63.0', desc: 'Luxación de muñeca' },

  // ── Cadera ────────────────────────────────────────────────────────
  { code: 'M16.0', desc: 'Coxartrosis primaria bilateral' },
  { code: 'M16.1', desc: 'Coxartrosis primaria unilateral' },
  { code: 'M16.5', desc: 'Coxartrosis postraumática' },
  { code: 'M70.6', desc: 'Bursitis trocantérea' },
  { code: 'M76.1', desc: 'Síndrome de psoas-ilíaco' },
  { code: 'M76.3', desc: 'Síndrome de la banda iliotibial' },
  { code: 'S72.0', desc: 'Fractura de cuello de fémur' },
  { code: 'S73.0', desc: 'Luxación de cadera' },

  // ── Rodilla ───────────────────────────────────────────────────────
  { code: 'M17.0', desc: 'Gonartrosis primaria bilateral' },
  { code: 'M17.1', desc: 'Gonartrosis primaria unilateral' },
  { code: 'M17.3', desc: 'Gonartrosis postraumática' },
  { code: 'M22.0', desc: 'Luxación recidivante de la rótula' },
  { code: 'M22.2', desc: 'Trastorno femoropatelar' },
  { code: 'M23.2', desc: 'Trastorno del menisco por desgarro antiguo' },
  { code: 'M23.3', desc: 'Trastorno del menisco — otra deformidad' },
  { code: 'M23.4', desc: 'Cuerpo libre en articulación de la rodilla' },
  { code: 'M70.4', desc: 'Bursitis prerrotuliana' },
  { code: 'M76.5', desc: 'Tendinitis rotuliana' },
  { code: 'M76.6', desc: 'Tendinitis aquílea' },
  { code: 'S83.0', desc: 'Luxación de rótula' },
  { code: 'S83.2', desc: 'Desgarro de menisco actual' },
  { code: 'S83.5', desc: 'Esguince de ligamento cruzado anterior' },
  { code: 'S83.4', desc: 'Esguince de ligamento colateral de la rodilla' },

  // ── Tobillo y pie ─────────────────────────────────────────────────
  { code: 'M19.1', desc: 'Artrosis postraumática de tobillo y pie' },
  { code: 'M77.3', desc: 'Espolón calcáneo' },
  { code: 'M72.2', desc: 'Fascitis plantar' },
  { code: 'S93.0', desc: 'Luxación de articulación del tobillo' },
  { code: 'S93.4', desc: 'Esguince de tobillo' },
  { code: 'S82.6', desc: 'Fractura de maleolo externo' },
  { code: 'S82.5', desc: 'Fractura de maleolo interno' },
  { code: 'S92.0', desc: 'Fractura de calcáneo' },

  // ── Artritis y artropatías ─────────────────────────────────────────
  { code: 'M05.0', desc: 'Artritis reumatoide seropositiva' },
  { code: 'M06.0', desc: 'Artritis reumatoide seronegativa' },
  { code: 'M08.0', desc: 'Artritis reumatoide juvenil' },
  { code: 'M10.0', desc: 'Gota idiopática' },
  { code: 'M13.0', desc: 'Poliartritis no especificada' },
  { code: 'M19.0', desc: 'Artrosis primaria de otras articulaciones' },
  { code: 'M45',   desc: 'Espondilitis anquilosante' },
  { code: 'M35.3', desc: 'Polimialgia reumática' },

  // ── Tejidos blandos / fibromialgia ────────────────────────────────
  { code: 'M79.7', desc: 'Fibromialgia' },
  { code: 'M79.1', desc: 'Mialgia' },
  { code: 'M79.2', desc: 'Neuralgia y neuritis no especificadas' },
  { code: 'M79.3', desc: 'Paniculitis no especificada' },
  { code: 'M62.4', desc: 'Contractura muscular' },
  { code: 'M62.5', desc: 'Atrofia muscular y desgaste no clasificada en otra parte' },
  { code: 'M65.1', desc: 'Otra tendinitis infecciosa' },
  { code: 'M65.2', desc: 'Tendinitis calcificante' },
  { code: 'M66.3', desc: 'Rotura espontánea de tendones flexores' },
  { code: 'M66.5', desc: 'Rotura espontánea de otros tendones' },

  // ── Neurológico ───────────────────────────────────────────────────
  { code: 'G35',   desc: 'Esclerosis múltiple' },
  { code: 'G20',   desc: 'Enfermedad de Parkinson' },
  { code: 'G80.0', desc: 'Parálisis cerebral espástica cuadriplejia' },
  { code: 'G80.1', desc: 'Parálisis cerebral espástica diplejia' },
  { code: 'G80.2', desc: 'Parálisis cerebral espástica hemiplejia' },
  { code: 'G80.9', desc: 'Parálisis cerebral no especificada' },
  { code: 'G81.0', desc: 'Hemiplejia flácida' },
  { code: 'G81.1', desc: 'Hemiplejia espástica' },
  { code: 'G81.9', desc: 'Hemiplejia no especificada' },
  { code: 'G82.0', desc: 'Paraplejia flácida' },
  { code: 'G82.1', desc: 'Paraplejia espástica' },
  { code: 'G82.5', desc: 'Tetraplejia no especificada' },
  { code: 'G83.1', desc: 'Monoplejia del miembro superior' },
  { code: 'G83.2', desc: 'Monoplejia del miembro inferior' },
  { code: 'G54.2', desc: 'Trastornos de raíces cervicales' },
  { code: 'G54.3', desc: 'Trastornos de raíces torácicas' },
  { code: 'G54.4', desc: 'Trastornos de raíces lumbosacras' },
  { code: 'G56.1', desc: 'Otras lesiones del nervio mediano' },
  { code: 'G56.2', desc: 'Lesión del nervio cubital' },
  { code: 'G56.3', desc: 'Lesión del nervio radial' },
  { code: 'G57.0', desc: 'Lesión del nervio ciático' },
  { code: 'G57.1', desc: 'Meralgia parestésica' },
  { code: 'G57.2', desc: 'Lesión del nervio femoral' },
  { code: 'G57.3', desc: 'Lesión del nervio peroneo' },
  { code: 'G60.0', desc: 'Neuropatía hereditaria motora y sensorial' },
  { code: 'G61.0', desc: 'Síndrome de Guillain-Barré' },
  { code: 'G71.0', desc: 'Distrofia muscular' },
  { code: 'G71.2', desc: 'Miopatías congénitas' },
  { code: 'G43.9', desc: 'Migraña no especificada' },
  { code: 'G50.0', desc: 'Neuralgia del trigémino' },
  { code: 'G51.0', desc: 'Parálisis de Bell' },

  // ── Accidente cerebrovascular ──────────────────────────────────────
  { code: 'I63.9', desc: 'Infarto cerebral no especificado' },
  { code: 'I64',   desc: 'Accidente vascular encefálico (ACV) no especificado' },
  { code: 'I69.1', desc: 'Secuelas de infarto cerebral' },
  { code: 'I69.3', desc: 'Secuelas de ACV' },

  // ── Lesiones traumáticas cabeza / cuello ──────────────────────────
  { code: 'S09.9', desc: 'Traumatismo craneoencefálico no especificado' },
  { code: 'S14.0', desc: 'Conmoción de la médula espinal cervical' },
  { code: 'S14.1', desc: 'Otro traumatismo de la médula espinal cervical' },
  { code: 'S24.1', desc: 'Otro traumatismo de la médula espinal torácica' },
  { code: 'S34.1', desc: 'Traumatismo de la médula espinal lumbar' },

  // ── Fracturas miembro superior ────────────────────────────────────
  { code: 'S42.0', desc: 'Fractura de clavícula' },
  { code: 'S42.2', desc: 'Fractura de húmero proximal' },
  { code: 'S42.3', desc: 'Fractura del cuerpo del húmero' },
  { code: 'S52.0', desc: 'Fractura de olécranon' },
  { code: 'S52.5', desc: 'Fractura distal del radio (Colles)' },

  // ── Fracturas miembro inferior ────────────────────────────────────
  { code: 'S72.1', desc: 'Fractura pertrocantérea' },
  { code: 'S72.3', desc: 'Fractura del cuerpo del fémur' },
  { code: 'S82.0', desc: 'Fractura de rótula' },
  { code: 'S82.1', desc: 'Fractura proximal de tibia' },
  { code: 'S82.2', desc: 'Fractura del cuerpo de la tibia' },
  { code: 'S82.3', desc: 'Fractura distal de tibia' },

  // ── Amputaciones ──────────────────────────────────────────────────
  { code: 'Z89.5', desc: 'Ausencia adquirida del miembro inferior a nivel de la pierna' },
  { code: 'Z89.6', desc: 'Ausencia adquirida del miembro inferior a nivel del fémur' },
  { code: 'Z89.2', desc: 'Ausencia adquirida del antebrazo' },

  // ── Respiratorio / Fisioterapia respiratoria ───────────────────────
  { code: 'J45.9', desc: 'Asma no especificada' },
  { code: 'J44.1', desc: 'EPOC con exacerbación aguda' },
  { code: 'J44.0', desc: 'EPOC con infección respiratoria aguda' },
  { code: 'J44.9', desc: 'EPOC no especificada' },
  { code: 'J18.9', desc: 'Neumonía no especificada' },
  { code: 'J98.1', desc: 'Colapso pulmonar / Atelectasia' },
  { code: 'J96.0', desc: 'Insuficiencia respiratoria aguda' },
  { code: 'J93.1', desc: 'Neumotórax espontáneo' },

  // ── Posquirúrgico / Rehabilitación ────────────────────────────────
  { code: 'Z96.6', desc: 'Presencia de prótesis articular de rodilla' },
  { code: 'Z96.4', desc: 'Presencia de prótesis articular de cadera' },
  { code: 'Z96.5', desc: 'Presencia de prótesis articular de hombro' },
  { code: 'Z47.0', desc: 'Cuidados de seguimiento de retiro de implante' },
  { code: 'Z47.8', desc: 'Cuidados de seguimiento tras cirugía ortopédica' },
  { code: 'Z50.1', desc: 'Fisioterapia' },
  { code: 'Z50.7', desc: 'Terapia ocupacional y rehabilitación vocacional' },
  { code: 'Z96.1', desc: 'Presencia de lentes intraoculares' },

  // ── Pediatría / Desarrollo ────────────────────────────────────────
  { code: 'G91.1', desc: 'Hidrocefalia obstructiva' },
  { code: 'Q65.0', desc: 'Luxación congénita de cadera unilateral' },
  { code: 'Q65.2', desc: 'Luxación congénita de cadera bilateral' },
  { code: 'Q66.0', desc: 'Pie equino varo congénito' },
  { code: 'M41.0', desc: 'Escoliosis infantil idiopática' },
  { code: 'G40.9', desc: 'Epilepsia no especificada' },
  { code: 'F84.0', desc: 'Trastorno del espectro autista' },
  { code: 'F90.0', desc: 'TDAH — trastorno por déficit de atención con hiperactividad' },
  { code: 'F82',   desc: 'Trastorno específico del desarrollo motor' },

  // ── Adulto mayor ──────────────────────────────────────────────────
  { code: 'M80.0', desc: 'Osteoporosis posmenopáusica con fractura patológica' },
  { code: 'M81.0', desc: 'Osteoporosis posmenopáusica sin fractura patológica' },
  { code: 'M84.4', desc: 'Fractura por estrés' },
  { code: 'R26.1', desc: 'Marcha espástica' },
  { code: 'R26.8', desc: 'Otras anormalidades de la marcha' },
  { code: 'R55',   desc: 'Síncope y colapso' },

  // ── Condiciones sistémicas con afectación musculoesquelética ──────
  { code: 'E11.6', desc: 'Diabetes mellitus tipo 2 con complicaciones neurológicas' },
  { code: 'E11.4', desc: 'Diabetes mellitus tipo 2 con complicaciones neurológicas periféricas' },
  { code: 'I73.0', desc: 'Síndrome de Raynaud' },
  { code: 'M34.0', desc: 'Esclerodermia sistémica progresiva' },
  { code: 'M33.1', desc: 'Dermatomiositis' },

  // ── Dolor crónico ─────────────────────────────────────────────────
  { code: 'G89.2', desc: 'Dolor crónico no clasificado en otra parte' },
  { code: 'G89.3', desc: 'Síndrome de dolor regional complejo tipo I' },
  { code: 'G89.4', desc: 'Síndrome de dolor regional complejo tipo II' },
  { code: 'R52',   desc: 'Dolor no clasificado en otra parte' },

  // ── Lesiones deportivas ───────────────────────────────────────────
  { code: 'M76.0', desc: 'Tendinitis glútea' },
  { code: 'M76.2', desc: 'Tendinitis del tendón calcáneo' },
  { code: 'M76.4', desc: 'Tendinitis tibial' },
  { code: 'M76.7', desc: 'Tendinitis peroneal' },
  { code: 'M79.4', desc: 'Hipertrofia infrapatelar (grasa de Hoffa)' },
  { code: 'S39.0', desc: 'Lesión muscular de la zona abdominal, lumbar y pelvis' },

  // ── Cefaleas / ATM ────────────────────────────────────────────────
  { code: 'G44.2', desc: 'Cefalea tensional' },
  { code: 'K07.6', desc: 'Trastorno de la articulación temporomandibular' },
];

export function searchCie10(query: string, limit = 10): Cie10Entry[] {
  const q = query.trim().toUpperCase();
  if (!q) return [];
  return CIE10.filter(
    e => e.code.startsWith(q) || e.desc.toUpperCase().includes(q)
  ).slice(0, limit);
}
